export default __webpack_public_path__ + "static/media/img22.ddb14c49.svg";